import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const StaffNotice = (props: any) => {
  const { ClientData } = props;

  return (
    <div className={tw`h-full w-full `}>
      <div
        className={tw`bg-primary-light w-full h-[200px] text-primary text-2xl flex items-center justify-center font-bold`}
      >
        Please Contact to Administrator
      </div>
      <div className="flex justify-center items-center">
        <img src={ClientData?.logo} />
      </div>
      <div
        className={tw`h-[30px] absolute bottom-0 w-full text-gray-700 flex items-center text-white  bg-primary p-2 justify-center  mt-4`}
      >
        <h1>Copyright ©2024 Careinfo Solutions</h1>
      </div>
    </div>
  );
};

export default StaffNotice;
